// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3xssZ","paramInput":"JobSimulator_paramInput__2i0h4","input":"JobSimulator_input__2r_Um"};